import first from 'lodash/first';

import type { ExploreTreeModel } from '../models/explore-tree-model';

export const getCurrentNode = (treeModel: ExploreTreeModel) => {
    const data = treeModel.getValue();
    const id = first(data.selection);
    return id && treeModel.getItemById(id)?.model;
};